import { useNewSession } from '@/hooks/useNewSession';
import { type SessionCreatedEntryPoint } from '@heidi/session/contracts';
import { type ParsedUrlQueryInput } from 'querystring';
import { useDebouncedCallback } from 'use-debounce';

interface UseDebouncedNewSessionOptions {
  delay?: number;
  leading?: boolean;
  queryParams?: ParsedUrlQueryInput;
  entryPoint?: SessionCreatedEntryPoint;
}

export const useDebouncedNewSession = (options: UseDebouncedNewSessionOptions = {}) => {
  const { delay = 1000, leading = true, queryParams, entryPoint } = options;

  const { createNewSession, isError, isPending } = useNewSession({
    queryParams,
    entryPoint,
  });

  const debouncedNewSessionClick = useDebouncedCallback(
    () => {
      createNewSession();
    },
    delay,
    {
      leading,
    }
  );

  return {
    debouncedNewSessionClick,
    isError,
    isPending,
  };
};
